<!--
 * @Description: 
 * @Date: 2022-03-10 15:51:30
-->
<template>
  <div class="toolbar_head_right">
    <div v-if="entpAuthStatus === 30" class="userInfo">
      <base-svg iconClass="zhanghao" style="font-size: 14px"></base-svg>
      <p class="name" style="color: #878d96">{{ defaultUserFnName }}</p>
    </div>

    <BaseDropdown @command="onCommand">
      <div class="name" style="margin-left: 10px; cursor: pointer">
        <span
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            line-clamp: 1;
            white-space: initial;
            word-break: break-all;
          "
          :title="userName"
        >
          {{ userName }}
        </span>
        <base-svg
          iconClass="zhankai"
          style="margin-left: 4px; font-size: 16px"
        ></base-svg>
      </div>

      <template #dropdown>
        <BaseDropdownMenu>
          <!-- 企业认证后平台审核通过后 -->
          <template v-if="entpAuthStatus === 30">
            <BaseDropdownItem command="info">
              <div style="box-sizing: border-box; padding-right: 100px">
                <base-svg
                  iconClass="qiyexingxi"
                  className="toolbar-item-svg"
                ></base-svg>
                企业信息
              </div>
            </BaseDropdownItem>
            <BaseDropdownItem command="billingMaintenance">
              <base-svg
                iconClass="kaipiao"
                className="toolbar-item-svg"
              ></base-svg>
              开票维护
            </BaseDropdownItem>
          </template>

          <BaseDropdownItem command="resetPassword">
            <base-svg
              iconClass="Password"
              className="toolbar-item-svg"
            ></base-svg>
            重置密码
          </BaseDropdownItem>
          <BaseDropdownItem command="logout">
            <base-svg
              iconClass="Logout"
              className="toolbar-item-svg"
            ></base-svg>
            退出登录
          </BaseDropdownItem>
        </BaseDropdownMenu>
      </template>
    </BaseDropdown>

    <template v-if="userFunction?.length > 1">
      <div class="line" style="margin: 0 16px"></div>

      <BasePopover
        v-if="entpAuthStatus === 30"
        placement="bottom"
        trigger="hover"
        :width="160"
      >
        <template #reference>
          <div class="name" style="cursor: pointer; flex-shrink: 0">
            <span>切换账号</span>
            <base-svg
              iconClass="zhankai"
              style="margin-left: 4px; font-size: 16px"
            ></base-svg>
          </div>
        </template>
        <ul class="toolbar__switch__accounts">
          <li
            class="switch__accounts__item"
            :class="{ hover: item.functionCode !== defaultUserFnCode }"
            v-for="(item, index) in userFunction"
            :key="index"
            @click="onChangeAccount(item.functionCode)"
          >
            <div class="switch__accounts__svg">
              <base-svg
                :iconClass="
                  {
                    1: 'gongye2',
                    2: 'fusushang',
                    3: 'gongyingshang'
                  }[item.functionCode]
                "
                className="toolbar-item-svg"
              ></base-svg>
              <span>{{ item.functionName }}</span>
            </div>

            <BaseIcon
              v-if="item.functionCode === defaultUserFnCode"
              style="color: #42be65"
            >
              <Check />
            </BaseIcon>
          </li>
        </ul>
      </BasePopover>
    </template>
  </div>
</template>

<script lang="ts" name="layout-toolbar" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { Check } from '@element-plus/icons-vue';
import {
  BaseDropdown,
  BaseDropdownMenu,
  BaseDropdownItem,
  useCreateModal,
  BasePopover,
  XrkMessage,
  BaseIcon
} from 'xrk-components';
import { storeToRefs } from 'pinia';

import appStore from '@/store';
import { BaseCompanyDialog } from '@/components/base/base-company/index';
import ChangePassword from './change-password.vue';
import { cutFunction } from '@/common/data-source/user/apis';
import { InvoiceEnterpriseDialog } from '@V/invoice/app';
import { useSetup } from '@/store/modules/user';
import { FunctionCode } from '@/common/types/user';

const router = useRouter();
const { logout, initUserSystemData } = appStore.useUserStoreSetup;
const { info, userFunction, defaultUserFnName, defaultUserFnCode } =
  storeToRefs(appStore.useUserStoreSetup);
const { menuUrls } = storeToRefs(appStore.useMenuStoreSetup);

const userName = computed(() => {
  const { entpAuthStatus, phone, entpName } = info.value;
  if (+entpAuthStatus === 30) return entpName;
  return phone;
});
const entpAuthStatus = computed(() => info?.value?.entpAuthStatus);

const onCommand = e => {
  switch (e) {
    case 'info':
      useCreateModal(BaseCompanyDialog);
      break;
    case 'resetPassword':
      useCreateModal(ChangePassword, {
        onSuccess: () => {
          logout();
        }
      });
      break;
    case 'logout':
      logout();
      break;
    case 'billingMaintenance':
      useCreateModal(InvoiceEnterpriseDialog);
      break;
  }
};
const loginStore = useSetup();

const onChangeAccount = async (functionCode: FunctionCode) => {
  if (functionCode === defaultUserFnCode.value) return;

  await cutFunction({ functionCode });
  XrkMessage.success('切换成功');
  window.sessionStorage.clear();
  // 切换职能后再次请求合同拦截
  loginStore.setInfo({
    ...info.value,
    shouldShowContractSign: true
  });
  initUserSystemData(() => {
    if (entpAuthStatus.value !== 30) {
      router.replace({
        path: '/',
        query: {
          force: Date.now()
        }
      });
      return;
    }

    if (!menuUrls.value?.[0]) {
      router.replace({
        path: '/',
        query: {
          force: Date.now()
        }
      });
    } else {
      router.replace({
        path: menuUrls.value[0],
        query: {
          force: Date.now()
        }
      });
    }
  });
};
</script>

<style lang="scss">
.toolbar_head_right {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-right: 20px;

  .userInfo {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  .name {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #121619;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .line {
    width: 1px;
    height: 12px;
    border: 1px solid #c1c7cd;
  }
}
.toolbar-item-svg {
  margin-right: 4px;
  font-size: 16px;
}

.toolbar__switch__accounts {
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  .switch__accounts__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    box-sizing: border-box;
    padding: 0 6px;

    &.hover {
      &:hover {
        cursor: pointer;

        background: #f2f4f8;
      }
    }

    .switch__accounts__svg {
      display: flex;
      align-items: center;
    }

    .switch__accounts__account {
      width: 61px;
      height: 22px;
      background: #defbe6;
      border-radius: 2px 2px 2px 2px;
      display: flex;
      align-items: center;
      justify-content: center;

      font-size: 12px;
      color: #42be65;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
